<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-1" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
<rect x="2" y="6" width="16" height="12" rx="2" stroke="currentColor" stroke-width="1.6"/>
<path d="M2 10h16" stroke="currentColor" stroke-width="1.6"/>
</svg>
</template>
